import { render } from "./ScrollToTopFloatingButton.vue?vue&type=template&id=42b350c5"
import script from "./ScrollToTopFloatingButton.vue?vue&type=script&lang=js"
export * from "./ScrollToTopFloatingButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__